import React from 'react';

import { useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import InformationIcon from '@atlaskit/icon/core/information';
import Link from '@atlaskit/link';
import { RovoIcon } from '@atlaskit/logo';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import { N40 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { ATLASSIAN_INTELLIGENCE_TRUST_LINK, ATLASSIAN_ROVO_LINK } from '../../../constants';
import { messages } from '../../../messages';

const styles = cssMap({
	container: {
		borderBottomWidth: token('border.width'),
		borderBottomStyle: 'solid',
		borderBottomColor: token('color.border', N40),
		paddingTop: token('space.100', '8px'),
		paddingBottom: token('space.100', '8px'),
	},
});

export function AIAnswerBottomBookend() {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.container}>
			<Inline alignBlock="center" spread="space-between">
				<Inline alignBlock="center">
					<InformationIcon
						label=""
						color={token('color.icon.subtle', '#626F86')}
						spacing="spacious"
					/>{' '}
					<Link
						rel="noopener noreferrer"
						appearance="subtle"
						href={ATLASSIAN_INTELLIGENCE_TRUST_LINK}
					>
						<Text size="small">
							{formatMessage(messages.ai_answer_dialog_footer_content_quality_long)}
						</Text>
					</Link>
				</Inline>
				<Inline alignBlock="center">
					<Link rel="noopener noreferrer" appearance="subtle" href={ATLASSIAN_ROVO_LINK}>
						<Text size="small">Rovo</Text>
					</Link>{' '}
					<RovoIcon label="" appearance="neutral" size="small" />
				</Inline>
			</Inline>
		</Box>
	);
}
